import type BigNumber from 'bignumber.js'

/**
 * Whether a trade made a holder or unmade one.
 *
 * The holder count otherwise moves only when the server has counted the
 * balances again, and it does that about once every three minutes per token
 * — measured on 2026-09-22, 3.6 rows per token per ten minutes in
 * `holder_counts`. A card rebuilt every three seconds cannot make a figure
 * that old move, so the number sat still while the market did not.
 *
 * Every trade already says what the wallet held before it and what it holds
 * after, so the two crossings that matter can be read straight off it: a
 * wallet arriving from nothing, and one leaving with nothing.
 */
export const holderDelta = (
  balanceBefore: BigNumber,
  balanceAfter: BigNumber,
): -1 | 0 | 1 => {
  const had = balanceBefore.isGreaterThan(0)
  const has = balanceAfter.isGreaterThan(0)

  if (!had && has) {
    return 1
  }
  if (had && !has) {
    return -1
  }
  return 0
}
